<template>
  <button class="border-0 ring-0" @click="isOpen = true">
    <FontAwesomeIcon
      :icon="['fal', icon]"
      fixed-width
      class="mx-2 text-gray-600"
    />
  </button>
  <Dialog :open="isOpen" class="relative z-50">
    <div
      class="fixed inset-0 flex w-screen items-center justify-center bg-black/20 p-4"
      @click="isOpen = false"
    >
      <DialogPanel
        class="flex w-[32rem] flex-col overflow-hidden rounded-xl bg-white shadow-xl"
      >
        <div class="relative aspect-video bg-gray-500">
          <img
            v-if="validStreetViewImg"
            class="absolute inset-0 aspect-video object-cover"
            :src="srcStreetview"
            @error="validStreetViewImg = false"
          />
          <img
            v-else
            class="absolute inset-0 aspect-video object-cover"
            :src="srcMap"
          />
          <button
            class="absolute top-2 right-2 flex aspect-square w-5 items-center justify-center rounded-full bg-white"
            @click="isOpen = false"
          >
            <FontAwesomeIcon :icon="['fal', 'times']" />
          </button>
        </div>
        <div class="bg-primary-100 flex flex-col gap-2 p-4">
          <DialogTitle class="text-lg leading-tight font-bold text-slate-800">
            {{
              place?.type == 'FPR' || type == 'OTHER'
                ? place?.full_name
                : place?.name
            }}
          </DialogTitle>
          <ViewData :data="dataViewDatas" size="small" />
        </div>
      </DialogPanel>
    </div>
  </Dialog>
</template>

<script>
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ViewData from '@c/ViewComponents/ViewData.vue'

export default {
  name: 'PlacePopoverComponent',
  components: {
    ViewData,
    DialogTitle,
    DialogPanel,
    Dialog,
    FontAwesomeIcon
  },
  props: {
    place: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: 'circle-info'
    },
    type: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      validStreetViewImg: true
    }
  },
  computed: {
    srcStreetview() {
      let url = `https://maps.googleapis.com/maps/api/streetview?size=960x540&scale=2&key=${import.meta.env.VITE_GOOGLE_MAP_API_KEY}&return_error_code=true`
      if (this.place.streetview) {
        let sv = this.place.streetview
        url += `&fov=${sv.fov}&zoom=${sv.zoom}&pitch=${sv.pitch}&heading=${sv.pitch}&location=${sv.latitude},${sv.longitude}`
      } else {
        url += `&location=${this.place.latitude},${this.place.longitude}`
      }
      return url
    },
    srcMap() {
      return `https://maps.googleapis.com/maps/api/staticmap?center=${this.place.latitude},${this.place.longitude}&size=960x540&sensor=true&zoom=14&markers=${this.place.latitude},${this.place.longitude}&scale=2&key=${import.meta.env.VITE_GOOGLE_MAP_API_KEY}&return_error_code=true`
    },
    dataViewDatas() {
      return [
        [
          [
            {
              label: `phone`,
              value: this.place.phone_field,
              gate: !!this.place.phone_field
            },
            {
              label: `mail`,
              value: this.place.mail,
              gate: !!this.place.mail
            },
            {
              label: `web`,
              value: this.place.web,
              gate: !!this.place.web
            }
          ]
        ],
        [
          [
            {
              label: 'address',
              value: `${this.place.street}\n${this.place.zip} ${this.place.city}`,
              gate: this.place.street || this.place.zip || this.place.city
            },
            {
              label: 'address',
              value: `${this.place.address}\n${this.place.site?.address.street}\n${this.place.site?.address.zip} ${this.place.site?.address.city}`,
              gate: this.place?.type === 'FPR'
            }
          ]
        ]
      ]
    }
  }
}
</script>
